/* eslint-disable react-hooks/exhaustive-deps */
import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import FormGroup from "@mostrans/web-components/components/base/FormGroup";
import Input from "@mostrans/web-components/components/base/Input";
import Select from "@mostrans/web-components/components/base/Select";
import { Box, Dialog, Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSetState } from "react-use";
import { createCandidateCourse, updateCandidateCourseByID } from "../../../../graphql/mutations";
import { swalAlert, toastError, toastSuccess } from "../../../../shared/helpers";
import { years } from "../../../../shared/listYears";
import { getCandidateByID } from "./../../../../graphql/query";
import Dropzone from "@mostrans/web-components/components/base/Dropzone";
import { uploadCourseCandidate } from "./../../../../shared/firebaseServices";
import { generateFileName } from "./../../../../shared/helpers";
import { useSetRecoilState } from "recoil";
import { globalLoadingAtom } from "../../../../shared/globalStates";

export default function Course({ open, setOpen, handleClose, data, setData, index }) {
  const client = useApolloClient();
  const [edit, setEdit] = useState(true);
  const [isEmpty, setIsEmpty] = useState(false);
  const setLoading = useSetRecoilState(globalLoadingAtom);
  const [values, setValues] = useSetState({
    id: "",
    course_category: "",
    course_organizer: "",
    course_year: "",
    link_certificate: "",
    invalid_message: "",
    pdf: [],
  });

  useEffect(() => {
    if (open[1]) {
      setValues({
        id: data.Courses[index].id,
        course_category: data.Courses[index].course_category,
        course_organizer: data.Courses[index].course_organizer,
        course_year: data.Courses[index].course_year,
        link_certificate: data.Courses[index].link_certificate,
        pdf: {
          name: data.Courses[index].link_certificate?.split("?")[0].split("-")[3],
        },
      });
    } else {
      setValues({
        id: "",
        course_category: "",
        course_organizer: "",
        course_year: "",
        link_certificate: "",
        pdf: "",
      });
    }
  }, [data, open]);

  useEffect(() => {
    if (data.length !== 0) {
      handleEdited();
    }
  }, [values]);

  const modalClose = () => {
    setOpen([false, false]);
    setIsEmpty(false);
  };

  const handleEdited = () => {
    if (data?.Courses === null || data.Courses === undefined) return setEdit(false);
    if (
      values.id !== data?.Courses[index]?.id ||
      values.course_category !== data?.Courses[index]?.course_category ||
      values.course_organizer !== data?.Courses[index]?.course_organizer ||
      values.course_year !== data?.Courses[index]?.course_year ||
      values.pdf.name !== data?.Courses[index]?.link_certificate?.split("?")[0].split("-")[3]
    ) {
      setEdit(false);
    } else {
      setEdit(true);
    }
  };

  const handleSubmit = async () => {
    if (!values.course_category || !values.course_organizer || !values.course_year) {
      setIsEmpty(true);
    } else {
      setLoading(true);
      if (open[1]) {
        try {
          let link_certificate;
          if (values.pdf.name) {
            const fileName = generateFileName("certificate-", values.pdf.name);
            link_certificate = await uploadCourseCandidate(values.pdf, fileName);
          }
          const editValue = {
            id: values?.id,
            course_category: values?.course_category,
            course_organizer: values?.course_organizer,
            course_year: values?.course_year,
            link_certificate: link_certificate || null,
          };
          const result = await updateCandidateCourseByID(client, editValue);
          if (result.status !== "000") {
            toastError(result.errMsg);
          } else {
            toastSuccess("Edit Course Success");
            setOpen([false, false]);
            getCandidateByID(client).then(setData);
          }
        } catch (error) {
          toastError();
        }
      } else {
        try {
          let link_certificate;
          if (values.pdf.name) {
            const fileName = generateFileName("certificate-", values.pdf.name);
            link_certificate = await uploadCourseCandidate(values.pdf, fileName);
          }
          const createValue = {
            course_category: values?.course_category,
            course_organizer: values?.course_organizer,
            course_year: values?.course_year,
            link_certificate: link_certificate || null,
          };
          const result = await createCandidateCourse(client, createValue);
          if (result.status !== "000") {
            toastError(result.errMsg);
          } else {
            toastSuccess("Add Course Success");
            setOpen([false, false]);
            getCandidateByID(client).then(setData);
          }
        } catch (error) {
          toastError();
        }
      }
      setLoading(false);
    }
  };
  return (
    <React.Fragment>
      <Button
        variant="text"
        color="primary"
        size="small"
        type="tertiary"
        onClick={() => setOpen([true, false])}
        startIcon={<span className="material-icons"> add </span>}
        sx={{ fontSize: "14px" }}>
        Add Course
      </Button>
      <Dialog open={open[0]} onClose={handleClose}>
        <Box>
          <Box p={2}>
            <Typography variant="h4">{open[1] ? "EDIT" : "ADD"} COURSE</Typography>
          </Box>
          <Divider />
          <Box p={2}>
            <Grid container spacing={1}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <FormGroup
                  className="font-size-main "
                  label="Course Organizer"
                  errorMessage={"Course Organizer cannot be empty!"}
                  isError={isEmpty && !values.course_category}
                  isRequired
                  showChildErrorSign>
                  <Input
                    id="organizer"
                    value={values.course_organizer}
                    onChange={(e) =>
                      setValues({
                        course_organizer: e.target.value.toUpperCase(),
                      })
                    }
                    type="text"
                    placeholder="Enter Course Organizer"
                    required
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <FormGroup
                  className="font-size-main"
                  label="Course Category"
                  errorMessage={"Course Category cannot be empty"}
                  isError={isEmpty && !values.course_category}
                  isRequired
                  showChildErrorSign>
                  <Input
                    id="category"
                    value={values.course_category}
                    onChange={(e) =>
                      setValues({
                        course_category: e.target.value.toUpperCase(),
                      })
                    }
                    type="text"
                    placeholder="Enter Course Category"
                    required
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                <FormGroup
                  className=" font-size-main"
                  label="Course Year"
                  errorMessage={"Course year cannot be empty"}
                  isError={isEmpty && !values.course_year}
                  isRequired
                  showChildErrorSign>
                  <Select
                    id="course_year"
                    name="course_year"
                    maxMenuHeight={150}
                    menuPlacement="top"
                    value={{
                      label: values.course_year ? values.course_year : "Select",
                    }}
                    onChange={(e) => setValues({ course_year: e.value })}
                    options={years().map((value) => ({
                      value: value,
                      label: value,
                    }))}
                  />
                </FormGroup>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                <Dropzone
                  id="upload_certificate"
                  name="upload_certificate"
                  onChange={(e) => setValues({ ...values, pdf: e[0] })}
                  accept=".pdf"
                  middleText={values.pdf?.name ? values.pdf?.name : "CLICK/DRAG YOUR FILE HERE"}
                  topText={"Upload Your Certificate!"}
                  bottomText={values.invalid_message}
                  onInvalid={(e) => {
                    setValues({ ...values, invalid_message: e });
                    swalAlert({ title: "Error", text: e });
                  }}
                />
              </Grid>
            </Grid>
          </Box>
          <Divider />
          <Box p={2} textAlign="end">
            <Button
              onClick={modalClose}
              variant="outlined"
              color="danger"
              style={{ margin: "0 10px" }}>
              Cancel
            </Button>
            <Button disabled={edit} onClick={handleSubmit} style={{ margin: "0 10px" }}>
              Save
            </Button>
          </Box>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}
